import React, { useState, Fragment } from "react";
import moment, { Moment } from "moment";
import LocationIcon from "./LocationIcon";
import { Event, PageConfigurationContextConsumer } from "./index";
const selectedIcon = require("./styles/selected.svg");

const UpcomingEventCard = ({
  event,
  handleEventSelection,
  isEventSelected
}: {
  event: Event;
  handleEventSelection: Function;
  isEventSelected: Function;
}) => {
  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <label
            className={`upcoming-ev-card ${
              isEventSelected(event) ? "shadow-effect" : ""
            } `}
          >
            <div
              className="upcoming-ev-date-badge"
              style={{
                color: pageConfiguration.primaryColor,
                borderColor: pageConfiguration.primaryColor
              }}
            >
              <p className="upcoming-ev-date-p1">{event.day}</p>
              <p className="upcoming-ev-date-p2">{event.month}</p>
              <p className="upcoming-ev-date-p3">{event.year}</p>
            </div>
            <div className="upcoming-ev-info-div">
              <p className="upcoming-ev-p">{event.name}</p>
              <div className="upcoming-ev-location-div">
                <div className="location-pin-img">
                  <LocationIcon color={pageConfiguration.primaryColor} />
                </div>
                <div>
                  <p className="completed-ev-location-p1 upcoming-location-span">
                    {event.location}
                  </p>
                  <p className="completed-ev-location-p2">{event.country}</p>
                </div>
              </div>
            </div>
            <div className="upcoming-ev-check-div">
              <input
                className="upcoming-ev-v-check"
                type="checkbox"
                checked={isEventSelected(event)}
                onChange={e => handleEventSelection(e, event)}
              />
              <div className="upcoming-ev-check"></div>
              {isEventSelected(event) && (
                <img src={selectedIcon} className="upcoming-ev-checked" />
              )}
            </div>
          </label>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default UpcomingEventCard;
